import moment from 'moment';
import { useEffect } from 'react';
import { MdInfo } from 'react-icons/md';
import { useInView } from 'react-intersection-observer';
import DataItem from 'components/DataItem';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';

export default function Overview({
  className = '',
  updateInView,
  overviewData,
}) {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const dateFormat = 'DD MMMM yyyy';
  const buildGuestString = (guestData) => {
    let { adults, children, infants } = guestData;

    adults = Number(adults);
    children = Number(children);
    infants = Number(infants);

    let guestString = '';
    if (adults) {
      guestString += `${adults} Adult${adults > 1 || adults === 0 ? 's' : ''}`;
    }
    if (children) {
      guestString += `, ${children} Child${
        children > 1 || children === 0 ? 'ren' : ''
      }`;
    }
    if (infants) {
      guestString += `, ${infants} Infant${
        infants > 1 || infants === 0 ? 's' : ''
      }`;
    }
    return guestString;
  };

  useEffect(() => {
    updateInView(inView);
  }, [inView, updateInView]);

  return (
    <div className={className} id="overview" ref={ref}>
      <SectionLabelWithIcon
        label="Overview"
        icon={<MdInfo />}
        className="pb-10 xs:pb-[45px]"
        iconContainerClassName="section-icon"
      />
      <div className="flex flex-wrap">
        <DataItem
          label="Name"
          value={overviewData.name}
          containerClassName="mb-[25px] xs:mb-[30px] leading-4"
          labelClassName="mb-[15px]"
        />
        <DataItem
          label="Booked"
          value={moment(Number(overviewData.created)).format(dateFormat)}
          containerClassName="mb-[25px] xs:mb-[30px] leading-4"
          labelClassName="mb-[15px]"
        />
        <DataItem
          label="Quote reference"
          value={overviewData.quoteReference}
          containerClassName="mb-[25px] xs:mb-[30px] leading-4"
          labelClassName="mb-[15px]"
        />
        <DataItem
          label="Guests"
          value={buildGuestString(overviewData)}
          containerClassName="mb-[25px] xs:mb-[30px] leading-4"
          labelClassName="mb-[15px]"
        />
        <DataItem
          label="Date from"
          value={moment(Number(overviewData.dateFrom)).format(dateFormat)}
          containerClassName="mb-[25px] xs:mb-[30px] leading-4"
          labelClassName="mb-[15px]"
        />
        <DataItem
          label="Date to"
          value={moment(Number(overviewData.dateTo)).format(dateFormat)}
          containerClassName="mb-[25px] xs:mb-[30px] leading-4"
          labelClassName="mb-[15px]"
        />
      </div>
    </div>
  );
}
